import * as bootstrap from 'bootstrap';

declare global {
  interface Window {
    bootstrap: typeof bootstrap;
  }
}

window.bootstrap = bootstrap;

window.addEventListener('DOMContentLoaded', () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
});

window.addEventListener('DOMContentLoaded', () => {
  const tabFilters = document.querySelectorAll('.tab-filter');
  tabFilters.forEach((tabFiltersContainer) => {
    const tabFilters = tabFiltersContainer.querySelectorAll('.nav-link');

    tabFilters.forEach((tabFilter) => {
      tabFilter.addEventListener('click', () => {
        tabFilters.forEach((tabFilterToDeactivate) => tabFilterToDeactivate.classList.remove('active'));
        tabFilter.classList.add('active');
      });
    });
  });
});
